export default "__VITE_ASSET__DU4pHTeR__"